import { SymbolLayer } from 'react-map-gl';

export const arrowDeliveriesLayer: SymbolLayer = {
  id: 'deliveriesDirections',
  type: 'symbol',
  paint: {},
  layout: {
    'symbol-placement': 'line',
    'icon-image': 'arrowDeliveries',
    'icon-rotation-alignment': 'map',
    'icon-allow-overlap': false,
    'icon-ignore-placement': true,
    'icon-size': 0.45,
  },
};

export const arrowStopsLayer: SymbolLayer = {
  id: 'stopsDirections',
  type: 'symbol',
  paint: {},
  layout: {
    'symbol-placement': 'line',
    'icon-image': 'arrowStops',
    'icon-rotation-alignment': 'map',
    'icon-allow-overlap': false,
    'icon-ignore-placement': true,
    'icon-size': 0.45,
  },
};

export const courierLayer: SymbolLayer = {
  id: 'courierDirections',
  type: 'symbol',
  paint: {},
  layout: {
    'symbol-placement': 'line',
    'icon-image': 'arrowCourier',
    'icon-rotation-alignment': 'map',
    'icon-allow-overlap': false,
    'icon-ignore-placement': true,
    'icon-size': 0.45,
  },
};

export const arrowCapacityPlanRoutesLayer: SymbolLayer = {
  id: 'capacityPlanRoutesDirections',
  type: 'symbol',
  paint: {},
  layout: {
    'symbol-placement': 'line',
    'icon-image': 'arrowStops',
    'icon-rotation-alignment': 'map',
    'icon-allow-overlap': false,
    'icon-ignore-placement': true,
    'icon-size': 0.45,
  },
};
